import CIcon from "@coreui/icons-react";
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div className="m-5">
          <h2>Something went wrong...</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
          <a href="/" className="text-info mt-4 d-flex align-items-center">
            <CIcon name="cil-home" className="mr-2" />
            Back to home page
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
